import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
  message: {
    marginRight: 'auto',
    marginBottom: 0,
  },
}));

export default function AdminFreeText({ freeText, center = false }) {
  const classes = useStyles();

  return (
    <>
      {freeText && freeText !== '' && (
        <>
          {center && (
            <>
              <Typography variant="h6" align="left">
                Below is a message from our team:
              </Typography>
              <Typography variant="h6" align="left">
                {freeText}
              </Typography>
            </>
          )}

          {!center && (
            <>
              <Typography paragraph align="left" className={classes.message}>
                Below is a message from our team:
              </Typography>
              <Typography paragraph align="left" className={classes.message}>
                {freeText}
              </Typography>
            </>
          )}
        </>
      )}
    </>
  );
}
